import { Spin } from "antd"
import styled from "styled-components"

const LoaderContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 100vh;
  width: 100%;
`

const BlackSpin = styled(Spin)`
  .ant-spin-dot-item {
    background-color: #000 !important;
  }
`

export const MainLoader = () => (
  <LoaderContainer>
    <BlackSpin size="default" />
  </LoaderContainer>
)
